<template>
  <div :class="addClasses">
    <span v-if="item.hasResult && item.result.loginLabel">{{ getTranslation(item.result.loginLabel) }}</span>
  </div>
</template>

<script>
export default {
  name: "ResultLoginLabelComponent",
  props: {
    item: {
      type: Object,
      required: true
    },
    addClasses:String
  }
}
</script>

<style scoped>

</style>
